import React, { useRef } from "react";

export const OTPInput = ({ otp, setOtp, disabled = false }) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    if (disabled) return;
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (disabled) return;
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, index) => (
        <input
          key={index}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={1}
          ref={(ref) => (inputRefs.current[index] = ref)}
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          // className=" bg-white rounded-md border border-solid border-stone-200 h-[50px] w-[50px] text-center text-2xl font-bold"
          // className={` bg-white rounded-md border text-[#333333] ${
          //   disabled
          //     ? "border-[#333333] text-[#333333] bg-gray-50"
          //     : "border-[#E9E6E4] text-[#999999] focus:text-[#333333] focus:border-[#3F54DF]"
          // } h-[50px] w-[50px] text-center text-2xl font-bold`}
          className={`
            bg-white rounded-md border text-2xl font-bold text-center
            h-[50px] w-[50px]
            outline-none
            transition-colors duration-200
            ${
              disabled
                ? "border-[#333333] text-[#333333] bg-gray-50 cursor-not-allowed"
                : digit
                ? "border-[#E9E6E4] text-[#333333]"
                : "border-[#E9E6E4] text-[#999999]"
            }
            focus:border-[#333333] focus:text-[#333333]
            focus:ring-0 focus:ring-offset-0
            focus:outline-none
            [-webkit-appearance:none] [appearance:none]
            [&::-webkit-outer-spin-button]:appearance-none
            [&::-webkit-inner-spin-button]:appearance-none
          `}
          style={{
            WebkitAppearance: "none",
            MozAppearance: "textfield",
            boxShadow: "none",
            outline: "none",
          }}
          aria-label={`OTP digit ${index + 1}`}
        />
      ))}
    </div>
  );
};
